import {
  IMyCareersPrioritize,
  IOnBoard,
  IPrioritizeItem,
  IReportCount,
  IUnlockNextGlimpse,
} from "interfaces/OnbaordingInterface";
import {
  CAREER_SELECTION_LIST,
  COMPLETE_ONBOARD,
  COUNT_REPORT,
  INTRODUCTION_VIDEO,
  LIST_PRIORITIZE,
  MY_CAREER,
  START_ONBOARD,
  UNLOCK_NEXT_CAREER,
  UNLOCK_ONBOARD,
} from "./endpoint-urls";
import axios from "./http-service";
import { IntroDTO } from "screens/media/media.screen";
import { transform } from "typescript";

export type CareerSelectionItem = {
  id: string;
  name: string;
  icon: string;
  icon_url: string;
  status: string;
  is_unlocked?: boolean;
};

export const getCareerSelectionList = () => {
  return axios
    .get<CareerSelectionItem[]>(CAREER_SELECTION_LIST)
    .then((res) => res.data);
};

export const unlockOnboard = (careerIds?: string[]) => {
  const body = careerIds ? { career_ids: careerIds } : {};
  return axios.post<any>(UNLOCK_ONBOARD, body).then((res) => res.data);
};

export const addIntroVideo = (data:IntroDTO) => {
  return axios.post<any>(INTRODUCTION_VIDEO,data).then((res) => res.data);
};

export const getIntroVideo = () => {
  return axios.get<any>(`${INTRODUCTION_VIDEO}`).then((res) => res.data);
};

export const unlockNextGlimpse = (careerIds?: string[]) => {
  const body = careerIds ? { career_ids: careerIds } : {};
  return axios.post<IUnlockNextGlimpse>(UNLOCK_NEXT_CAREER, body).then((res) => res.data);
};

export const startOnBoard = (userPage: number) => {
  return axios
    .get<IOnBoard>(`${START_ONBOARD}?page=${userPage}`)
    .then((res) => res.data);
};
export const completeOnBoard = () => {
  return axios.post(`${COMPLETE_ONBOARD}`, {}).then((res) => res.data);
};

export const prioritizeCareer = (body: IPrioritizeItem) => {
  return axios
    .put<IMyCareersPrioritize[]>(`${MY_CAREER}/${body.id}/prioritize`, body,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        transformRequest: [(data, headers) => {
          headers["Content-Type"] = "application/json";
          return JSON.stringify(data);
      }],
})
    .then((res) => res.data);
};

export type BulkPrioritizeItem = {
  id: string;
  order: number;
  category: "top_three" | "watch_list" | "discard";
};

export const bulkPrioritizeCareers = (items: BulkPrioritizeItem[]) => {
  return axios
    .put<IMyCareersPrioritize[]>(`${MY_CAREER}/bulk-prioritize`, { items })
    .then((res) => res.data);
};

export const ListPrioritize = () => {
  return axios
    .get<IMyCareersPrioritize[]>(`${LIST_PRIORITIZE}`)
    .then((res) => res.data);
};

export const markVideoViewed = (expertVoiceId: string, timeSpent: number) => {
  return axios
    .post(
      `${MY_CAREER}/mark-video-viewed`,
      {
        expert_voice_id: expertVoiceId,
        time_spent: Math.round(timeSpent),
      },
      // _silent: the hook handles failure locally — don't surface a toast
      { _silent: true } as any
    )
    .then((res) => res.data);
};

export const getCountReport = () => {
  return axios.get<IReportCount>(`${COUNT_REPORT}`).then((res) => res.data);
};
